import { ArticlesSortByParams } from '../../../../../constants';
import { APICallInterface } from 'app/scripts/services/sagas/types';

export const fetchArticlesFilterTagsApiCall = (): APICallInterface => ({
  types: [
    'FETCH_ARTICLES_FILTER_TAGS_REQUEST',
    'FETCH_ARTICLES_FILTER_TAGS_SUCCESS',
    'FETCH_ARTICLES_FILTER_TAGS_FAILURE'
  ],
  params: {
    method: 'GET',
    url: '/host-panel/mba/tags',
    queryParams: {
      sortBy: ArticlesSortByParams.Newest,
      count: 100,
      offset: 0
    }
  }
});

const TAGS_LIMIT = 50;

export interface FetchArticlesFilterTagsPayload {
  search: string;
  offset: number;
  useV2?: boolean;
}

export interface FetchArticlesFilterTagsResponse {
  tags: Array<string>;
  offset?: number;
}

export const fetchArticlesFilterTagsRequest = (
  args: FetchArticlesFilterTagsPayload
): APICallInterface => ({
  types: [
    'FETCH_ARTICLES_FILTER_TAGS_REQUEST',
    'FETCH_ARTICLES_FILTER_TAGS_SUCCESS',
    'FETCH_ARTICLES_FILTER_TAGS_FAILURE'
  ],
  params: {
    method: 'GET',
    url: '/host-panel/mba/v2/tags',
    queryParams: { ...args, limit: TAGS_LIMIT }
  }
});
